import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setUser } from '../features/userSlice';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import '../styles/Auth.css';

const AuthPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const toggleForm = () => {
    setIsLogin(prev => !prev);
    setError('');
    setSuccessMessage('');
    setFormData({ username: '', email: '', password: '' });
  };

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    try {
    if (isLogin) {
      const { data } = await axios.post('/api/auth/login/', {
        email: formData.email,
        password: formData.password
      });

      // Сохраняем оба токена
      localStorage.setItem('accessToken', data.access);
      localStorage.setItem('refreshToken', data.refresh);
      dispatch(setUser({ user: data.user, token: data.access }));
      navigate('/');
      } else {
        // Отправляем все поля для регистрации
        await axios.post('/api/auth/register/', formData);
        setSuccessMessage('Вы успешно зарегистрировались! Пожалуйста, войдите.');
        setIsLogin(true);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Произошла ошибка.');
    }
  };

  return (
    <div className="auth-page">
      <Helmet>
        <title>{isLogin ? 'Вход' : 'Регистрация'} - Car Rental</title>
      </Helmet>
      <div className="auth-container">
        <h1>{isLogin ? 'Вход' : 'Регистрация'}</h1>
        {error && <p className="auth-message error">{error}</p>}
        {successMessage && <p className="auth-message success">{successMessage}</p>}
        <form className="auth-form" onSubmit={handleSubmit}>
          {!isLogin && (
            <div>
              <label>Имя пользователя:</label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required={!isLogin} // Обязательно только при регистрации
              />
            </div>
          )}
          <div>
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label>Пароль:</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="auth-button">
            {isLogin ? 'Войти' : 'Зарегистрироваться'}
          </button>
        </form>
        <p className="auth-toggle">
          {isLogin ? 'Нет аккаунта?' : 'Уже есть аккаунт?'}
          <button type="button" onClick={toggleForm} className="toggle-button">
            {isLogin ? 'Зарегистрироваться' : 'Войти'}
          </button>
        </p>
      </div>
    </div>
  );
};

export default AuthPage;